<template>
  <div>
    <vxe-grid
      ref="skuTable"
      auto-resize
      highlight-hover-row
      resizable
      show-footer
      size="mini"
      cell-class-name="align-top"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :max-height="635"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
      :footer-method="() => footerData"
      @edit-closed="editClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>

      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <div>{{ row.goodsName }}</div>
          <div>{{ row.goodsNameEn }}</div>
          <div>
            <span>SIZE:</span><span>{{ row.goodsSize }}</span>
          </div>
          <div>
            <span>COLOR:</span
            ><span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <div class="m-0">
          <div>NC:{{ row.amzSkuNcNo }}</div>
          <div>SKU:{{ row.amzSkuNo }}</div>
        </div>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; "
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width: 60px;" />
          </div>
        </el-image>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="remove(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import {
  format,
  add,
  multiply,
  divideDown,
  divideRound,
} from '@/libs/util.number.js'
export default {
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: this.disabled ? { query: () => this.$emit('reload') } : null,
        zoom: true,
        custom: true,
      },
      tableData: [],
      calcTableData: [],
      format: (number) => format(number),
      tableColumns: tableColumns(this),
      editRules: {
        ncNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        purchasePrice: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        poNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        inboundQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        ctnQty: [
          {
            required: true,
            pattern: /^[0-9]+$/,
            message: '入库箱数必须为整箱，请检查入库数量是否填写正确！',
          },
        ],
        ctnLength: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        ctnWidth: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        ctnHeight: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        ctnGrossWeight: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.calcTableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[3] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  methods: {
    setData(data) {
      this.tableData = data
      this.calcTableData = data
    },
    async resetCalcTable() {
      this.calcTableData = await this.getTableData()
      this.$refs.skuTable.updateFooter()
    },
    async remove(row) {
      await this.$refs.skuTable.remove(row)
      this.resetCalcTable()
      this.$emit('change', await this.getTableData())
    },
    async insertAt(records, row = -1) {
      const result = await this.$refs.skuTable.insertAt(records, row)
      this.$emit('change', await this.getTableData())
      await this.resetCalcTable()
      return result
    },
    async editClosed({ row }) {
      const {
        purchasePrice,
        inboundQty,
        inCtnQty,
        ctnLength,
        ctnWidth,
        ctnHeight,
        ctnGrossWeight,
      } = row

      const ctnQty = divideDown(inboundQty, inCtnQty, 2)
      const subAmount = multiply(purchasePrice, inboundQty)
      const subGrossWeight = multiply(ctnGrossWeight, ctnQty)
      const subCbm = multiply(
        divideRound(
          multiply(multiply(ctnLength, ctnWidth), ctnHeight),
          1000000,
          2
        ),
        ctnQty
      )

      row.ctnQty = ctnQty
      row.subCbm = subCbm
      row.subGrossWeight = subGrossWeight
      row.subAmount = subAmount
      this.resetCalcTable()
      this.$emit('change', await this.getTableData())
    },
    async validate() {
      const tableData = await this.getTableData()
      if (!tableData || !tableData.length) {
        this.$message.error(this.$l('tips_pleaseAddSku') || '请添加产品明细！')
        return false
      }
      const result = await this.$refs.skuTable.validate(true)
      return !result
    },
    async getTableData() {
      const { tableData } = await this.$refs.skuTable.getTableData()
      return tableData
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
